import { recordEvent } from "@/lib/nemmp/base/tracking/usage/recordEvent";
import { Track } from "@/modules/track/Track";
import { makeTrackCurrent } from "./makeTrackCurrent";

export async function playTrack(track: Track) {
  recordEvent("play-track");
  return await makeTrackCurrent(track, { play: true });
}
